"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.removeSelf = exports.handleRest = void 0;
var _this = void 0;
var handleRest = exports.handleRest = function handleRest(fn, removing) {
  for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }
  var fun = fn && fn.bind.apply(fn, [_this].concat(args));
  if (removing && fun) {
    fun();
  }
};
var removeSelf = exports.removeSelf = function removeSelf(setState, payload) {
  var fun = setState.bind(_this);
  fun({
    removing: payload
  });
};